import { render, staticRenderFns } from "./zixun.vue?vue&type=template&id=5d5c1031&scoped=true&"
import script from "./zixun.vue?vue&type=script&lang=js&"
export * from "./zixun.vue?vue&type=script&lang=js&"
import style0 from "./zixun.vue?vue&type=style&index=0&id=5d5c1031&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c1031",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/sit-app-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5c1031')) {
      api.createRecord('5d5c1031', component.options)
    } else {
      api.reload('5d5c1031', component.options)
    }
    module.hot.accept("./zixun.vue?vue&type=template&id=5d5c1031&scoped=true&", function () {
      api.rerender('5d5c1031', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/zixun.vue"
export default component.exports